import React, { InputHTMLAttributes } from "react";
import { FormError } from "@3gaam/shared/types/error";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, ""> & {
  error?: FormError;
  groupName?: string;
  label?: string | null;
};

const RadioBoxField = ({
  onChange,
  name,
  value,
  checked,
  groupName,
  label,
  className = "",
  children,
  error,
}: Props) => {
  let showError = name && error?.hasError && error?.dataError?.[name];
  return (
    <>
      <div
        className={`inp-box d-flex ${
          showError ? "invalid-field" : ""
        } ${className}`}
      >
        <div className="custom-control custom-radio">
          <input
            type="radio"
            name={groupName}
            value={value}
            onChange={onChange}
            checked={checked}
            className="custom-control-input"
            id={name}
          />
          <label className="custom-control-label mr-2" htmlFor={name}>
            {label}
          </label>
        </div>
        {children}
      </div>
      {name && showError && (
        <p className="text-red font-12 mt-1">{error?.dataError?.[name]}</p>
      )}
    </>
  );
};

RadioBoxField.defaultProps = {
  onChange: () => {},
  name: "",
  value: "",
  checked: false,
  groupName: "",
  label: "",
  children: null,
  error: null,
};

export default RadioBoxField;
